import { useState } from 'react';

export interface useModalReturn {
  show: boolean;
  toggle: () => void;
  onHide: () => void;
}

export const useModal = (): useModalReturn => {
  const [show, setShow] = useState<boolean>(false);

  const toggle = () => setShow(!show);
  const onHide = () => setShow(false);

  return {
    show,
    onHide,
    toggle,
  };
};
